<section id="auditorium">
  <div class="content-container">
    <div class="content">
      <img class="auditorium-icon" src="./images/nitt_logo.png"/>

      <h2 class="section-heading">Venue</h2>
      <p class="section-subtitle font-weight-bold">OFFLINE</p>
      <p class="section-subtitle">National Institute of Technology Tiruchirappalli ,Tamil Nadu, India</p>

      <p class="section-subtitle font-weight-bold">ONLINE</p>
      <p class="section-subtitle">The presentation platform  will be informed soon</p>

    </div>
  </div>
</section>

<section id="contact">
  <div class="content-container">
    <div class="content">
      <p class="section-heading">
        Contact
      </p>

      <p class="auditorium-phone">
        Dr K. Sivaprasad, Conference Chairman <br/>
        Associate Professor,<br/>
        Department of Metallurgical and Materials Engineering<br/>
        National Institute of Technology, Tiruchirappalli - 620015,<br/> Tamil Nadu, India
        <br/>
      Phone: +91-(0)431-2503466 (office)
      Mobile: +91-9444192278
        <br/>
        E-Mail : kspiitm13@gmail.com
      </p>
      <br/>

      <p class="auditorium-phone">
        Dr. N. Ramesh Babu, Conference Chairman<br/>
        Associate Professor,<br/>
        Department of Metallurgical and Materials Engineering<br/>
        National Institute of Technology, Tiruchirappalli, India
      <br/>Phone: 9944932221<br/>E-mail: nrb@nitt.edu</p>
      <br/>

      <p class="auditorium-phone">
        Dr. Prince Gideon, Conference Secretary <br/>
        Assistant Professor,<br/>
        Department of Metallurgical and Materials Engineering<br/>
        National Institute of Technology, Tiruchirappalli - 620015,<br/> Tamil Nadu, India<br/>
      Phone: +91-(0)431-2503463 (office)
      Mobile: +91-9843550816<br/>
        E-Mail : prince@nitt.edu
      </p>
      <br/>

      <p class="auditorium-phone">
        Dr. -Ing. K. G. Prashanth, Conference Chairman<br/>
        Professor in Additive Manufacturing,<br/>
        Dept of Mechanical and Industrial Engineering<br/>
        Tallinn University of Technology, Estonia
      <br/>Phone: +91-9789832337 (temporary)<br/>
        E-mail: kgprashanth@gmail.com</p>
        <br/>

      <p class="auditorium-phone">
        Bestin B Thomas, Member, organising committee<br/>
        Student,<br/>
        Department of Metallurgical and Materials Engineering<br/>
        National Institute of Technology, Tiruchirappalli, India
      <br/>E-mail: 112118008@nitt.edu</p>
    </div>
  </div>
</section>
